import styles from './DialogTitle.module.scss';
import React from 'react';
import clsx from 'clsx';
import iconX from '@static/images/icon_x.svg';
import iconArrow from '@static/images/icon_arrow.svg';
import { useDialogContext } from '../DialogContext.ts';
import { Image } from '../../Image/Image.tsx';
export function DialogTitle({ children, onBack }) {
    const { onClose, size } = useDialogContext();
    return /*#__PURE__*/ React.createElement("h2", {
        className: clsx(styles.title, {
            [styles.compact]: size == 'compact'
        })
    }, onBack ? /*#__PURE__*/ React.createElement("div", {
        className: styles.titleButton,
        onClick: onBack
    }, /*#__PURE__*/ React.createElement(Image, {
        image: {
            src: iconArrow,
            alt: 'strings:colonistCommon.buttons.back'
        },
        className: styles.buttonIcon
    })) : /*#__PURE__*/ React.createElement("span", {
        className: styles.buttonSpacer
    }), /*#__PURE__*/ React.createElement("span", {
        className: styles.titleText
    }, children), /*#__PURE__*/ React.createElement("div", {
        className: styles.titleButton,
        onClick: onClose
    }, /*#__PURE__*/ React.createElement(Image, {
        image: {
            src: iconX,
            alt: 'strings:colonistCommon.buttons.close'
        },
        className: styles.buttonIcon
    })));
}
